/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import { defineComponent } from 'vue';
import { render } from '../lib';
import { VmMuteControl, VmControl, VmIcon, VmTooltip } from '@vime/core';
import { define } from '../lib';
define('vm-mute-control', VmMuteControl);
define('vm-control', VmControl);
define('vm-icon', VmIcon);
define('vm-tooltip', VmTooltip);
export default defineComponent({
    emits: ['vmFocus', 'vmBlur'],
    methods: {},
    render: render('vm-mute-control', ['vmFocus', 'vmBlur']),
});
//# sourceMappingURL=MuteControl.js.map